import isUnauthorizedResponse from '../isUnauthorizedResponse';
export default function createUnauthorizedApiResponseHandler(apiFunc, ...args) {
    return unauthorizedHandler => apiFunc(...args).catch(apiError => {
        if (isUnauthorizedResponse(apiError)) {
            if (unauthorizedHandler) {
                return unauthorizedHandler(apiError);
            }
        }
        throw apiError;
    });
}
